import { render, staticRenderFns } from "./editBusinessPlan.vue?vue&type=template&id=0b2e3ffc"
import script from "./editBusinessPlan.vue?vue&type=script&lang=js"
export * from "./editBusinessPlan.vue?vue&type=script&lang=js"
import style0 from "./editBusinessPlan.vue?vue&type=style&index=0&id=0b2e3ffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports